<template>
  <section class="p-6 max-w-6xl mx-auto">
    <div class="flex items-end justify-between mb-5 gap-4 flex-wrap">
      <div>
        <h1 class="font-heading font-bold text-xl">Callia Core — SMS Flows</h1>
        <p class="text-[13px] text-gray-500 dark:text-dark-text-muted mt-1">
          7 flows · Recipient &amp; Sender · Last updated June 3, 2025
        </p>
      </div>
      <div class="relative">
        <search-icon
          class="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
        />
        <input
          type="text"
          placeholder="Search flows…"
          class="field pl-9 w-56"
          aria-label="Search flows"
        />
      </div>
    </div>

    <!-- Legend -->
    <div class="card card-body mb-6 flex gap-3 items-center text-[12.5px]">
      <info-icon class="w-4 h-4 text-brand-teal flex-shrink-0" />
      <div>
        Each flow contains variations based on:
        <strong>consent status</strong> (day-before opt-in vs. existing) ·
        <strong>order timing</strong> (morning vs. afternoon) ·
        <strong>weather</strong> (hot / cold / perfect) ·
        <strong>building type</strong> (house / townhouse / apartment / business
        / hospital)
      </div>
    </div>

    <!-- RECIPIENT -->
    <div class="flex items-center gap-2.5 mb-4">
      <span class="badge badge-teal text-xs px-2.5 py-1">Recipient flows</span>
      <span class="text-xs text-gray-500 dark:text-dark-text-muted"
        >Sent to the person receiving the flowers</span
      >
    </div>

    <div
      class="mb-2 text-xs font-semibold uppercase tracking-wider text-gray-400 dark:text-dark-text-muted"
    >
      🚗 Callia Driver delivery
    </div>
    <div class="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-6">
      <flow-card
        v-for="card in library.recipientDriver"
        :key="'rd-' + card.name"
        :card="card"
        @click.native="go('editor')"
      />
    </div>

    <div
      class="mb-2 text-xs font-semibold uppercase tracking-wider text-gray-400 dark:text-dark-text-muted"
    >
      📦 Courier delivery
    </div>
    <div class="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-6">
      <flow-card
        v-for="card in library.recipientCourier"
        :key="'rc-' + card.name"
        :card="card"
        @click.native="go('editor')"
      />
    </div>

    <!-- SENDER -->
    <div class="flex items-center gap-2.5 mb-4">
      <span class="badge badge-pink text-xs px-2.5 py-1">Sender flows</span>
      <span class="text-xs text-gray-500 dark:text-dark-text-muted"
        >Sent to the person who placed the order</span
      >
    </div>
    <div class="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
      <flow-card
        v-for="card in library.sender"
        :key="'sn-' + card.name"
        :card="card"
        @click.native="go('editor')"
      />
    </div>
  </section>
</template>

<script setup>
import { getCurrentInstance } from "vue";
import { SearchIcon, InfoIcon } from "vue-feather-icons";
import { FLOW_LIBRARY } from "./sms-config";
import FlowCard from "./components/FlowCard.vue";

const library = FLOW_LIBRARY;

const { proxy } = getCurrentInstance();
function go(route) {
  proxy.$router.push(`/secure/sms-portal/${route}`);
}
</script>
